module.exports={render:function (){with(this) {
  return _h('div', {
    ref: "head",
    staticClass: "menu-header"
  }, [_h('div', {
    staticClass: "header-title fixed",
    style: (titleBg)
  }, [_h('a', {
    staticClass: "header-menu",
    style: (menuPos),
    on: {
      "click": toggleMenu
    }
  }), " ", _h('p', {
    ref: "title",
    style: (titlePos),
    attrs: {
      "id": "title"
    }
  }, [_s(shopInfo.shopTitle)]), " ", _h('div', {
    staticClass: "search-wrap",
    class: {
      show: isSearching
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        toggleSearch($event)
      }
    }
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (filterKeyComputed),
      expression: "filterKeyComputed"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "placeholder": "搜索菜品"
    },
    domProps: {
      "value": _s(filterKeyComputed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) return;
        filterKeyComputed = $event.target.value
      }
    }
  }), " ", _h('span', {
    staticClass: "search-icon",
    class: icoStyle
  }), " ", _m(0)])]), " ", _h('div', {
    staticClass: "header-address"
  }, ["地址：" + _s(shopInfo.shopAddress)]), " ", _h('div', {
    staticClass: "header-tel"
  }, ["电话：" + _s(shopInfo.shopTel)]), " ", _h('div', {
    staticClass: "header-describe"
  }, [_s(shopInfo.shopDesc)])])
}},staticRenderFns: [function (){with(this) {
  return _h('span', {
    staticClass: "search-cancel"
  }, ["取消"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-655d30cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuHeader.vue
 ** module id = 74
 ** module chunks = 1
 **/